import Vue from 'vue';
import Icon from '@/components/icon';
import Lazyload from '@/components/lazyload';
import TableOfContents from '@/components/blog/table-of-contents';
import {
  UnlockPro,
  UnlockAdvancedAnalytics,
  CtaForm,
  PromoBox,
} from '@/components/referral';
import { BlogImg } from '@/components/blog';
import { Button, Fragment } from '@campsite-bio/component-lib';

Vue.component(Icon.name, Icon);
Vue.component(Lazyload.name, Lazyload);
Vue.component(TableOfContents.name, TableOfContents);
Vue.component(UnlockPro.name, UnlockPro);
Vue.component(UnlockAdvancedAnalytics.name, UnlockAdvancedAnalytics);
Vue.component(CtaForm.name, CtaForm);
Vue.component(PromoBox.name, PromoBox);
Vue.component(BlogImg.name, BlogImg);
Vue.component('Fragment', Fragment);
Vue.component('Btn', Button);
